/* Controller Imports */
import DashboardMainPageController from "./dashboard.controller";
import DashboardNotesModalController from "./table/list/notes-modal/note.controller";
/* Component Imports */
import DashboardAlertsListComponent from "./table/list/list.component";
import DashboardChartComponent from "./chart/chart.component";
/* Directive Imports */
import DashboardFiltersAndExportDirective from "./table/header-filters/header.component";

const dashboardModule = angular
  .module("app.dashboard", ["ui.bootstrap", "ui.router", "gettext"])
  /* Controllers */
  .controller("DashboardMainPageController", DashboardMainPageController)
  .controller("DashboardNotesModalController", DashboardNotesModalController)
  /* Components */
  .component("alertDashboardChart", DashboardChartComponent)
  .component("alertsBoardTable", DashboardAlertsListComponent)
  /* Directives */
  .directive("alertsBoard", DashboardFiltersAndExportDirective);

export default dashboardModule.name;